export const registrationSection = {
  title: 'Персональные данные',
  note: 'Для покупки более 10 билетов или индивидуальных условий — пишите менеджеру',
  back: { label: 'Назад', href: '/tariff' },
  fields: [
    {
      name: 'email',
      type: 'email',
      placeholder: 'Электронная почта',
      autocomplete: 'email',
      hint: 'Укажите личную почту. Не корпоративную. С корпоративной бывают сложности при входе в личный кабинет.',
      hintLink: { label: 'Подробнее в FAQ', href: '/#questions' }
    },
    { name: 'name', type: 'text', placeholder: 'Имя', autocomplete: 'given-name' },
    { name: 'surname', type: 'text', placeholder: 'Фамилия', autocomplete: 'family-name' },
    {
      name: 'phone',
      type: 'tel',
      placeholder: '+7 (___) ___-__-__',
      autocomplete: 'tel',
      hint: 'Исключительно для экстренной связи. Звонки и спам исключены.'
    },
    { name: 'city', type: 'text', placeholder: 'Город', autocomplete: 'address-level2' }
  ],
  agreements: [
    { name: 'offerContract', required: true, prefix: 'Принимаю', link: { text: 'Договор оферты', href: '/offer' } },
    { name: 'privacyPolicy', required: true, prefix: 'Принимаю', link: { text: 'Политику конфиденциальности', href: '/privacy' } },
    { name: 'userAgreement', required: false, prefix: 'Принимаю', link: { text: 'Пользовательское соглашение', href: '/agreement' } },
    { name: 'codeOfConduct', required: false, prefix: 'Обязуюсь соблюдать', link: { text: 'Нормы поведения', href: '/conduct' } },
    { name: 'personalData', required: true, label: 'Даю согласие на обработку персональных данных' },
    { name: 'newsletter', required: false, label: 'Даю согласие на получение рекламной рассылки' }
  ],
  submit: { label: 'Купить' },
  alreadyOrdered: {
    title: 'Вы уже оформили заказ',
    description: 'Заказ создан в этой вкладке в течение последнего часа. Если оплата прошла — он уже в личном кабинете. Если оплату ещё не закончили — продолжите её на странице YooKassa.',
    accountCta: { label: 'Перейти в кабинет', href: '/account' },
    newOrderCta: { label: 'Купить ещё один билет' }
  },
  promo: {
    placeholder: 'Промокод',
    apply: 'Применить',
    clear: 'Сбросить',
    hint: 'Введите промокод, если есть',
    applied: 'Промокод применён',
    pattern: '^[A-Za-z0-9\\-]+$'
  },
  verify: {
    title: 'Подтверждение email',
    description: 'Мы отправили код подтверждения на ваш email. Введите его ниже.',
    placeholder: 'Код из письма',
    submit: 'Подтвердить и оплатить',
    resend: 'Отправить код повторно',
    back: '← Назад'
  }
};

import { ENV } from '../config/env.generated.js';

export const productMap = {
  online:   { label: 'Онлайн',  price: 1000,  envKey: 'GIGMA_PRODUCT_ONLINE',   fallback: 34192 },
  basic:    { label: 'Базовый', price: 7000,  envKey: 'GIGMA_PRODUCT_BASIC',    fallback: 33729 },
  business: { label: 'Бизнес',  price: 12000, envKey: 'GIGMA_PRODUCT_BUSINESS', fallback: 33730 },
  vip:      { label: 'VIP',     price: 20000, envKey: 'GIGMA_PRODUCT_VIP',      fallback: 33731 }
};

export function resolveProductId(slug) {
  const entry = productMap[slug] ?? productMap.basic;
  const fromEnv = Number(ENV[entry.envKey]);
  if (Number.isFinite(fromEnv) && fromEnv > 0) return fromEnv;
  return entry.fallback;
}

export function resolveProductMeta(slug) {
  return productMap[slug] ?? productMap.basic;
}

/**
 * Обратное резолвение: по числовому productId возвращает slug ('basic'/'business'/'vip'),
 * чтобы UI ('Ваш заказ' блок) показывал правильный тариф и цену для маркетинговых
 * ссылок типа `/registration?productId=33731`. Если id неизвестен — null
 * (caller использует fallback от ?product= или 'basic').
 */
export function resolveProductSlug(id) {
  if (!Number.isFinite(id) || id <= 0) return null;
  for (const [slug, entry] of Object.entries(productMap)) {
    const fromEnv = Number(ENV[entry.envKey]);
    if (Number.isFinite(fromEnv) && fromEnv > 0 && fromEnv === id) return slug;
    if (entry.fallback === id) return slug;
  }
  return null;
}

export const TICKET_QTY_MIN = 1;
export const TICKET_QTY_MAX = 10;
